import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../common/Breadcrumbs'
import About from './About'
import Service from './Service'
import Choose from './Choose'
import Counter from './Counter'
import Process from './Process'
import ClientTestimonials from './Testimonial'
import TeamMembers from './TeamMembers'
import { axiosInstance, config } from '../config'
import Loader from "../../common/Loader"
import { Helmet } from 'react-helmet'

const AboutIndex = () => {

    const [data ,setdata] = useState([]);
    const [loading,setLoading] = useState([]);
    useEffect(() => {
        getData();
    },[])


    const getData = () => {
        setLoading(true)
        axiosInstance.get(`settings`)
            .then(res => {
                setdata(res?.data?.settings)
                // console.log(res?.data?.settings[6]?.image)
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <div>
            <Helmet>
                <title>{data[6]?.metatitle || "Precision Contract Cleaning"}</title>
                <meta name="description" content={data[6]?.metadescription || "Precision Contract Cleaning"} />
                <meta name="keywords" content={data[6]?.metakeywords || "Precision Contract Cleaning"} />
            </Helmet>
            {loading && <Loader/>}
            <Breadcrumbs title={data[6]?.title} description={data[6]?.subtitle} image={data[6]?.imageUrl} />

            <About data = {data}/>
            <Service />
            <Choose />
            <Counter />
            <Process />
            <ClientTestimonials />
            <TeamMembers />
        </div>
    )
}

export default AboutIndex
